import BackgroundDataLoaderWorker from 'web-worker:./BackgroundDataLoaderWorker';
import {ReadOptions} from "ol/format/Feature";
import {FeatureLike} from "ol/Feature";
import GeoJSON from "ol/format/GeoJSON";
import {MediaType} from "../data/MediaTypes";
import {ILoader} from "./ILoader";
import {ForegroundDataLoader, foregroundTypes} from "./ForegroundDataLoader";


export class BackgroundDataLoader implements ILoader {
    loadFile(file: File, mediaType: MediaType, readOptions?: ReadOptions, extraFiles: File[] = []): Promise<FeatureLike[]> {
        const worker = new BackgroundDataLoaderWorker() as Worker;
        const fmt = new GeoJSON();

        const mt = mediaType || file.type as MediaType;

        if (foregroundTypes.includes(mt)) {
            return (new ForegroundDataLoader()).loadFile(file, mediaType, readOptions);
        }

        const result: Promise<FeatureLike[]> = new Promise((resolve, reject) => {
            worker.postMessage([file, mediaType, readOptions, extraFiles]);

            const results = [];

            worker.onmessage = function (e) {
                const data = e.data;

                if ('error' in data) {
                    console.warn(data.error);
                    reject(data.error);
                    return;
                }

                if ('feature' in data) {
                    results.push(fmt.readFeature(data.feature));
                    return;
                }

                if ('done' in data && data.done) {
                    resolve(results);
                    return;
                }
            }
        });

        result.finally(() => worker.terminate());

        return result;
    }
}